
const state = {
  paymentsToggleHeaders: [
    { id: 'payment_date', display: true },
    { id: 'balance', display: true }
  ],
  quickstartDrawer: false,
  // estado de los paneles plegables, persistido como preferencia del usuario
  // ([0] abierto, [] cerrado). ui completo va a localStorage via persistedstate
  panels: {
    banks: [0],
    reminderIndicators: []
  },
  testMode: false
}

const actions = {
  TOGGLE_HEADERS: ({ commit }, { resource, columnId }) => {
    commit('TOGGLE_HEADERS', { resource, columnId })
  }
}

const mutations = {
  SET_TEST_MODE (state, value) {
    state.testMode = value
  },
  TOGGLE_QUICKSTART_DRAWER (state, value) {
    state.quickstartDrawer = typeof value === 'boolean' ? value : !state.quickstartDrawer
  },
  SET_PANEL: (state, { panel, value }) => {
    state.panels = { ...state.panels, [panel]: value }
  },
  TOGGLE_HEADERS: (state, { resource, columnId }) => {
    const headers = state[`${resource}ToggleHeaders`]

    state[`${resource}ToggleHeaders`] = headers.map(e => {
      if (e.id === columnId) {
        return {...e, display: !e.display}
      }
      return e
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
